<template>
  <div>
    <AllMoreFeedArticles ref="OpenFeedDialog"></AllMoreFeedArticles>
    <v-card flat>
      <p class="title text-center pt-2">
        <span class="pr-5">Article Feed (last 10)</span>
       <v-btn class="primary" @click="$refs.OpenFeedDialog.openDialog(item)">Open Dialog</v-btn>
      </p>
      <v-divider></v-divider>
      <v-divider></v-divider>
      <v-card-text>
        <div v-for="item in articleData.slice(0, 10)" :key="item.id">
          <p class="subtitle-1 mb-0 pb-0">
            <span class="font-weight-bold pr-2">Article title:</span>
            <span >{{item.Title}}</span>
          </p>
          <p class="subtitle-1 mt-0 mb-0 pt-0 pb-0">
            <span class="font-weight-bold pr-2">By:</span>
            <span>{{item.Nickname}}</span>
          </p>
          <p class="subtitle-1 mb-0 pb-0">
            <span class="font-weight-bold pr-2">Created</span>
            <span>{{item.Created | moment('LLL')}}</span>
          </p>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// Import funcitons from store.js (vuex)
import { mapActions } from "vuex";
import AllMoreFeedArticles from "@/pages/admin/components/statistic/articles/dialog/statisticArticleFeedDialog"
export default {
  components:{
    AllMoreFeedArticles
  },
  data(){
    return{
      // Contain the data from the API call made in GET_LAST_ARTICLES
      articleData: [],
      openDialog: false,
    }
  },
  methods:{
    // Import these functions from store.js
    ...mapActions([
      "GET_LAST_ARTICLES"
    ]),
    // Get all the data, including CreatedDays which through moment will display in correct form.
    getAllArticleData(){
      this.GET_LAST_ARTICLES().then(response => {
        this.articleData = response;
      })
    }
  },
  // Run this function when page are loaded
  mounted() {
    this.getAllArticleData();
  }
}
</script>